import React, { Component } from "react";
import styles from "./cmsCreateDeviceTools.module.scss";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import { withDevices } from "../../../shared/containers/containerDevices";
import { withAuth } from "../../../shared/containers/containerAuth";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import Input from "../../../shared/items/contols/input";
import { states } from "../../../reducers/queriesStates";
import { MenuItem, Select, Checkbox, FormGroup, FormControlLabel, InputLabel, FormControl } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

let timeOutId = null;

class CmsCreateDeviceTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isView: false,
      model: {
        imei: null,
        type: 0,
        model: null,
        phone: null,
        numberSim: null,
        usePattern: true,
        companyId: null,
        unitTitle: null,
        registerNumber: null,
      },
    };
  }

  componentDidMount() {
    const { onGetProtocolMarkers, onGetDevicePatterns } = this.props;
    onGetProtocolMarkers();
    onGetDevicePatterns();
  }

  componentDidUpdate(prevProps) {
    const { createDeviceDataState, onGetDevices } = this.props;
    const { model } = this.state;

    if (createDeviceDataState === states.READY && prevProps.createDeviceDataState === states.REQUEST) {
      onGetDevices(model.imei);
    }
  }

  onViewHandler() {
    const { isView } = this.state;
    const { onClickCreatepanelView } = this.props;

    this.setState({ isView: !isView });
    onClickCreatepanelView(!isView);
  }

  onHandleChangeStore(name, value) {
    const { model } = this.state;
    model[name] = value;
    this.setState({ model });

    if (name === "imei") {
      clearTimeout(timeOutId);

      const { onGetDevices } = this.props;

      const onSearchTerm = () => {
        onGetDevices(model[name]);
      };

      timeOutId = setTimeout(onSearchTerm, 200);
    }
  }

  selectDeviceType() {
    const { model } = this.state;
    const { protocolMarkers } = this.props;
    if (protocolMarkers === null) return null;

    return (
      <div>
        <Select
          style={{ minWidth: "200px", height: "36px", color: "#888888" }}
          onChange={(e) => {
            this.onHandleChangeStore("type", e.target.value);
          }}
          value={model.type}
        >
          {protocolMarkers.protocolMarkers.map((x, index) => {
            return (
              <MenuItem key={index} value={x.value} className={styles.MuiButtonBase_resolve}>
                {x.title}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }

  selectCompany() {
    const { ownershipAreas } = this.props;
    const companies = [];

    ownershipAreas.ownershipAreas.forEach((area) => {
      const areaTitle = ` (${area.title})`;

      area.companies.forEach((company) => {
        companies.push({
          id: company.id,
          title: `${company.title} ${areaTitle}`,
        });
      });
    });

    return (
      <div>
        <InputLabel>Создать в компанию</InputLabel>
        <Select
          style={{ minWidth: "200px", height: "36px", color: "#888888" }}
          onChange={(e) => {
            this.onHandleChangeStore("companyId", e.target.value);
          }}
        >
          {companies
            .sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0))
            .map((x) => {
              return (
                <MenuItem key={x.id} value={x.id} className={styles.MuiButtonBase_resolve}>
                  {x.title}
                </MenuItem>
              );
            })}
        </Select>
      </div>
    );
  }

  patterPanel() {
    const { isView, model } = this.state;
    const { devicePatterns, protocolMarkers } = this.props;

    if (!isView || devicePatterns === null || devicePatterns.patterns.length === 0 || !model.usePattern) return null;

    const pattern = devicePatterns.patterns.filter((x) => {
      return x.protocolType === model.type;
    })[0];

    if (pattern.patterns.length === 0) return null;

    const _protocolMarkers = protocolMarkers.protocolMarkers.filter((x) => {
      return x.value === pattern.protocolType;
    })[0];

    return (
      <div className={styles.createDevicePatternContainer}>
        <div className={styles.patternRow}>
          <div>ДАТЧИК</div>
          <div>МАРКЕР ВХОДА</div>
          <div>ДЕЛИТЕЛЬ</div>
          <div>МАСКА</div>
          <div>СМЕЩЕНИЕ</div>
          <div>№ ЭЛЕМЕНТА</div>
        </div>

        {pattern.patterns.map((x) => {
          const marker = _protocolMarkers.markers.filter((m) => {
            return m.value === x.marker;
          })[0];

          return (
            <div className={styles.patternRow}>
              <div>{x.sensorTitle}</div>
              <div>
                {marker.title} <b>{marker.code}</b>
              </div>
              <div>{x.divider}</div>
              <div>{x.mask}</div>
              <div>{x.term}</div>
              <div>{x.separatedItem}</div>
            </div>
          );
        })}
      </div>
    );
  }

  onCreateDeviceHancleClick() {
    const { onCreateDevice } = this.props;
    const { model } = this.state;

    onCreateDevice(model);
  }

  createPanel() {
    const { isView, model } = this.state;
    if (!isView) return null;

    const disableCreateButton = model.companyId === null;

    return (
      <div className={styles.createDeviceInputsContainer}>
        <div className={styles.createInputRow}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={model.usePattern}
                  onChange={(e) => {
                    this.onHandleChangeStore("usePattern", e.target.checked);
                  }}
                  color={"primary"}
                  style={{ paddingLeft: "10px" }}
                />
              }
              label="Использовать шаблон подлючения датчиков"
            />
          </FormGroup>
        </div>
        <div className={styles.createInputRow}>
          <Input name="imei" type="text" handleChangeStore={this.onHandleChangeStore.bind(this)} placeholder="IMEI" />
          {this.selectDeviceType()}
          <Input name="model" type="text" handleChangeStore={this.onHandleChangeStore.bind(this)} placeholder="Модель устройства" />
        </div>

        <div className={styles.createInputRow}>
          <Input name="phone" type="text" handleChangeStore={this.onHandleChangeStore.bind(this)} placeholder="Телефон SIM" />
          <Input name="numberSim" type="text" handleChangeStore={this.onHandleChangeStore.bind(this)} placeholder="Серийный номер SIM" />
        </div>
        <div className={styles.createInputRow}>
          <Input name="unitTitle" type="text" handleChangeStore={this.onHandleChangeStore.bind(this)} placeholder="Наименование ТС" />
          <Input name="registerNumber" type="text" handleChangeStore={this.onHandleChangeStore.bind(this)} placeholder="Рег. номер" />
        </div>
        <div className={styles.createInputRow}>
          {this.selectCompany()}
          <div className={styles.createButtonContainer}>
            <ButtonPrimary disabled={disableCreateButton} handleClick={this.onCreateDeviceHancleClick.bind(this)} title="Создать" />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { data, ownershipAreasDataState } = this.props;

    if (!data.permissions.includes(30014)) return null;
    if (ownershipAreasDataState !== states.READY) return null;

    return (
      <div className={styles.createDeviceContainer}>
        <div className={styles.createPanelViewButton}>
          <TooltipWrapper title={"Создать устройство"} position="top">
            <ControlPointIcon fontSize="large" onClick={this.onViewHandler.bind(this)} />
          </TooltipWrapper>
        </div>
        <div style={{ display: "flex" }}>
          {this.createPanel()} {this.patterPanel()}
        </div>
      </div>
    );
  }
}

export default withAuth(withDevices(withCompanies(React.memo(CmsCreateDeviceTools))));
